import { Client } from 'src/app/entities/client/client';
import { ClientDto } from 'src/app/services/remote-data-service/dtos/client.dto';
import { Mapper } from './mapper';

export class ClientMapper extends Mapper<Client, ClientDto> {
  constructor() {
    super()
  }

  mapToEntity(dto: ClientDto): Client {
    return new Client(
      dto.uuid,
      dto.name
    );
  }
}
